import {LaravelPageRequest} from './../../../../models/laravel-page-request.model';
import {AssetEditPopupComponent} from './../../asset/asset-edit/asset-edit-popup.component';
import {ModelAttributeOptionService} from './../../../../services/api/model-attribute-option.service';
import {BaseTableComponent} from '@shared/components/base/base-table.component';
import {Component, Injector, OnInit} from '@angular/core';
import {egretAnimations} from '@shared/animations/egret-animations';
import {PpmCreateComponent} from '@shared/components/business/ppm/ppm-create/ppm-create.component';
import {MatDialog} from '@angular/material';
import {PpmService} from '@app/shared/services/api/ppm.service';
import {DisplayColumnsService} from '@app/shared/services/display-columns.service';
import {GlobalSettingConfig} from '@shared/interfaces/global-setting-config';
import {GlobalSettingService} from '@shared/services/system/global-setting.service';

@Component({
  selector: 'app-ppm-list',
  templateUrl: './ppm-list.component.html',
  animations: egretAnimations
})
export class PpmListComponent extends BaseTableComponent implements OnInit {
  public items: any[];

  public get conditions() {
    return this.service.conditions;
  };


  constructor(
    protected injector: Injector,
    public _service: PpmService,
    private mao: ModelAttributeOptionService,
    private dialog: MatDialog,
    public service: PpmService,
    public displayColumnsService: DisplayColumnsService,
    private globalSettingService: GlobalSettingService,
  ) {
    super(injector);
  }

  ngOnInit() {
    this.layout.onRefresh
      .takeWhile(() => !this.destroy)
      .subscribe(() => this.refresh());
    this.globalSettingService.config$
      .takeWhile(() => !this.destroy)
      .subscribe((config: GlobalSettingConfig) => {
        if (config.useCompanyId) {
          this.refresh();
        }
      });
  }

  openAssetEditPage(row) {
    this.dialog.open(AssetEditPopupComponent, {
      width: '960px',
      disableClose: true,
      data: {id: row.id, title: 'Asset Edit(' + row.id + ')'}
    }).afterClosed()
      .subscribe((data: any) => {
        if (data) {
          this.items.splice(row.rowIndex, 1, data);
          this.items = [...this.items];
          this.toast.show('Asset Updated');
        }
      });
  }

  openPPMSelectAddPage() {
    if (this.tableComponent.selected.length > 0) {
      const asset_ids = [];
      this.tableComponent.selected.map((row: any) => {
        asset_ids.push(row.id);
      });
      this.dialog.open(PpmCreateComponent, {
        width: '960px',
        disableClose: true,
        data: {asset_ids: asset_ids}
      }).afterClosed()
        .subscribe((data: any) => {
          if (data) {
            this.tableComponent.selected = [];
            this.toast.show('PPM Add success!');
          }
        });
    } else {
      this.toast.show('Please choice asset');
    }
  }

  openPPMSingleAddPage($event) {
    this.tableComponent.selected = [$event];
    this.openPPMSelectAddPage();
  }

  openPPMAllAddPage() {
    if (this.conditions.category && this.conditions.category.value) {
      let request = new LaravelPageRequest(
        10, 0, this.conditions, '', {paginate_type: 'all'}
      );
      this.tableComponent.selected = [];
      let loader = this.loader.open();
      this.service.index(request)
        .finally(() => loader.close())
        .subscribe((data: any) => {
          const asset_ids = [];
          data.map((row: any) => {
            asset_ids.push(row.id);
          });
          this.dialog.open(PpmCreateComponent, {
            width: '960px',
            disableClose: true,
            data: {asset_ids: asset_ids}
          }).afterClosed()
            .subscribe((result: any) => {
              if (result) {
                this.tableComponent.selected = [];
                this.toast.show('PPM Add success!');
              }
            });
        });
    } else {
      this.toast.show('Please choice a category');
    }
  }

  getSorts($event) {
    let canSort = false;
    this.displayColumnsService.configs.ppm.displayedColumns.forEach((item) => {
      if (item.key === $event.sort_column && item.canSort) {
        canSort = true;
        $event.sort_column = item.sortColumnName;
        $event.sort_table = item.columnTable;
      }
    });

    if (canSort) {
      return $event;
    }

    return {};
  }
}
